import { z } from 'zod';
import { activityTypeSchema, cursorQuerySchema, idSchema, taskStatusSchema, utcDateTimeSchema, } from './common.js';
/**
 * Registro de auditoría. La tabla es *append-only*: nunca se edita ni se borra,
 * por eso no lleva `updatedAt` ni `deletedAt`.
 *
 * `oldValue` y `newValue` son texto: el valor serializado del campo, o `null`
 * cuando no aplica (por ejemplo en los cambios de `description`, de los que se
 * registra el evento pero no el contenido).
 */
export const activitySchema = z.object({
    id: idSchema,
    taskId: idSchema,
    actorId: idSchema,
    type: activityTypeSchema,
    field: z.string().max(60).nullable(),
    oldValue: z.string().nullable(),
    newValue: z.string().nullable(),
    createdAt: utcDateTimeSchema,
});
/** Campos cuyo cambio genera una fila de `activity`. Ver CLAUDE.md §4. */
export const AUDITED_TASK_FIELDS = [
    'title',
    'status',
    'assigneeId',
    'size',
    'priority',
    'dueDate',
    'projectId',
];
export const auditedTaskFieldSchema = z.enum(AUDITED_TASK_FIELDS);
/**
 * Lo que cuenta como "destacado" en el histórico global del Inicio (fase 7):
 * qué se creó, cerró o movió de estado, reasignó, comentó, borró o restauró.
 * Los retoques de talla, prioridad, fecha, título o descripción quedan fuera:
 * son ruido en un resumen de lo último que se ha trabajado.
 */
export const HIGHLIGHT_ACTIVITY_TYPES = ['created', 'commented', 'deleted', 'restored'];
export const HIGHLIGHT_ACTIVITY_FIELDS = ['status', 'assigneeId'];
/** `GET /activity`. Todos los filtros son combinables. */
export const activityFeedQuerySchema = cursorQuerySchema.extend({
    projectId: idSchema.optional(),
    actorId: idSchema.optional(),
    /** Marca UTC incluida: solo actividad desde este momento. */
    since: utcDateTimeSchema.optional(),
    /** Solo `HIGHLIGHT_ACTIVITY_TYPES` y los cambios de `HIGHLIGHT_ACTIVITY_FIELDS`. */
    highlights: z.stringbool().default(false),
});
/**
 * Una fila del histórico global, con lo mínimo de su tarea para pintarla sin
 * otra petición. El título no reutiliza `taskTitleSchema` porque `task.ts`
 * ya importa este fichero.
 */
export const activityFeedItemSchema = activitySchema.extend({
    task: z.object({
        id: idSchema,
        title: z.string(),
        projectId: idSchema,
        status: taskStatusSchema,
        /** Las tareas borradas siguen apareciendo: el histórico no se reescribe. */
        deletedAt: utcDateTimeSchema.nullable(),
    }),
    /** Solo en `commented`: el principio del comentario, o `null` si ya se borró. */
    commentExcerpt: z.string().nullable(),
});
//# sourceMappingURL=activity.js.map